<template>
    <popup :show="true" width="800px" @on-close="onClose">
        <div class="member-add">
            <div class="pop-title">添加成员加入团队</div>
            <div class="pop-desc">添加成员加入团队,一起共享服装设计资源库吧</div>
            <div class="pop-form">
                <div :class="['invite-list',{'list-focus':input_focus}]">
                    <div v-for="(item,index) in invite_list" :key="index" class="invite-item">
                        {{item}} <Icon type="md-close" class="remove-icon cursor" @click="removeInvite(index)" />
                    </div>
                    <input type="text" placeholder="请输入用户手机号,以回车分隔" v-model="invite_account" @keyup.enter="onAddAccount" @focus="input_focus=true" @blur="onInputblur" />
                </div>
                <div :class="['confirm-btn',{active:invite_list.length>0}]" @click="onInvite">确认添加</div>
            </div>
        </div>
    </popup>
</template>
<script> 
import { inviteMembers } from '@/api/index';
import Popup from '@/components/Popup.vue';
export default{
    components:{
        Popup
    },
    props:{
        teamId:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            invite_list:[],
            invite_account:'',
            input_focus:false,
            team_id:''
        }
    },
    mounted(){
        this.team_id = this.teamId;
    },
    methods:{
        onInputblur(){
            this.onAddAccount();
            this.input_focus = false;
        },
        async onInvite(){
            try{
                const {invite_list,team_id} = this;
                if(!team_id){
                    this.$layer.msg('团队ID异常');
                    return;
                }
                if(!invite_list.length){
                    this.$layer.msg('邀请账号不能为空');
                    return;
                }
                const {code,msg} = await inviteMembers({uuid:this.team_id,members:this.invite_list});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('邀请成功');
                this.$emit('on-invite-success');
                this.$emit('on-close');
            }catch(e){
                console.log('err-invite-member',e);
                this.$layer.msg(e.msg);
            }
        },
        removeInvite(index){
            this.invite_list.splice(index,1)
        },
        onAddAccount(){
            console.log('e,add-acc-->',this.invite_account);
            const {invite_account} = this;
            if(!invite_account) return;
            this.invite_list.push(invite_account);
            this.invite_account = '';
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .member-add{
        width:100%;
        min-height:280px;
        background:#ffffff;
        border-radius:15px;
        padding:51px 45px 63px 41px;
        display:flex;
        flex-direction:column;
        .pop-title{
            color:#1a1a1a;
            font-size:24px;
            font-weight:bold;
        }
        .pop-desc{
            color:#666666;
            font-size:14px;
            margin-top:19px;
        }
        .pop-form{
            width:100%;
            display:flex;
            align-items:flex-start;
            column-gap:10px;
            margin-top:48px;
            .invite-list{
                flex:1;
                max-width:554px;
                min-height:60px;
                flex-shrink:0;
                display:flex;
                align-items:center;
                flex-wrap:wrap;
                column-gap:5px;
                border:1px solid #c0c4cc;
                border-radius:5px;
                padding:8px;
                gap:8px;
                &.list-focus{
                    border:1px solid #ff5967;
                }
                .invite-item{
                    width:fit-content;
                    height:44px;
                    display:flex;
                    align-items:center;
                    column-gap:3px;
                    padding:0 10px;
                    color:#333333;
                    font-size:16px;
                    border:1px solid #dde1eb;
                    border-radius:5px;
                    background:#f7f7f7;
                    .remove-icon{
                        font-size:16px;
                        color:#999999;
                    }
                }
                input{
                    border:none;
                    outline:none;
                    background:transparent;
                    flex:1;
                    max-width:100%;
                }
            }
            .confirm-btn{
                width:150px;
                height:60px;
                line-height:60px;
                border-radius:5px;
                background:#f0f0f0;
                color:#999999;
                font-size:14px;
                text-align:center;
                cursor:not-allowed;
                &.active{
                    background:#ff5967;
                    color:#ffffff;
                    cursor:pointer;
                }
            }
        }
    }
</style>